import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import Button from 'components/controls/Button';
import _validator from 'modules/validator';
import { routes } from 'routes/Routes';
import _authService from 'modules/AuthService';
import { Icon, Modal } from 'antd';
import _notification from 'modules/notification';
import { withRouter } from "react-router";
import { BLACKLISTED_IP_MESSAGE } from 'constants/constants';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Stage 3.9 (Task 2/5): validation messages are set via setState with a plain string, so they use the
// plain resolveText() helper — see ResetPassword.jsx's identical comment for why.
function tr(key) {
  return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class NewLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationID: "",
      applicationIDState: "",
      password: "",
      passwordState: "",
      passwordError: "",
      isLoginSuccess: "",
      isLoading: false,
      isRegistrationEnabled: true,
      registrationDisable: this.props.registrationDisable ? this.props.registrationDisable : false,
      // Phase C.6.1 (Candidate Homepage & Login Modernization): the Application ID/Password/Login/
      // Forgot-Password form now renders inside a compact Modal instead of permanently occupying the
      // homepage sidebar — see render() below. No authentication logic changes; only this open/close
      // flag and where the same JSX is mounted.
      isLoginModalVisible: false
    };
    this.homePageLink = React.createRef();
  }

  openLoginModal = () => {
    this.setState({ isLoginModalVisible: true });
  }

  closeLoginModal = () => {
    this.setState({ isLoginModalVisible: false });
  }

  componentDidMount() {
    this.getIpAddress();
  }

  getIpAddress = async (ev) => {

    this.setState({ isLoading: true });
    try {
      const response = await _authService.getClientIP();

      if (response) {
        this.setState({ isLoading: false, isRegistrationEnabled: true })
      }
      else {
        this.setState({ isLoading: false, isRegistrationEnabled: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  onTextChange = ({ target: { name, value } }) => {
    switch (name) {
      case "applicationID":
        if (_validator.verifyNumber(value)) {
          if (value.length > 10) {
            return;
          }
          else {
            this.setState({
              [name + "State"]: "success",
              [name + "Error"]: ""
            });
          }
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: tr("login.invalidApplicationId")
          });
        }
        break;

      case "password":
        if (_validator.verifyBlank(value)) {
          if (value.length > 25) {
            return;
          }
          else {
            this.setState({
              [name + "State"]: "success",
              [name + "Error"]: ""
            });
          }
        } else {
          this.setState({
            [name + "State"]: "error",
            [name + "Error"]: tr("login.invalidPassword")
          });
        }
        break;

      default:
        this.setState({ [name + "State"]: "success" });
    }
    this.setState({ [name]: value, isLoginSuccess: "" });
  }

  handleLogin = async (ev) => {
    ev.preventDefault();
    if (this.state.applicationIDState === "success" && this.state.passwordState === "success") {
      this.setState({ isLoading: true });
      try {
        const response = await _authService.login({ Application_Id: this.state.applicationID, Password: this.state.password });
        if (response.status == 200 && response.data.Application_Id) {
          _authService.setSessionData(response.data);
          window.setTimeout(() => {
            this.setState({ isLoading: false })
            this.homePageLink.current.click();
          }, 3000);
        }
        else {
          this.setState({ isLoading: false })
          _notification.showMessage('error', response.data.Message);
        }
      } catch (e) {
        this.setState({ isLoading: false });
      }
    }
    else {
      if (this.state.applicationIDState === "") {
        this.setState({ applicationIDState: "error", applicationIDError: tr("login.invalidApplicationId") });
      }
      if (this.state.passwordState === "") {
        this.setState({ passwordState: "error", passwordError: tr("login.invalidPassword") });
      }
    }
  }

  // align-items-center m-auto
  render() {
    return (
      <>
        {(this.state.isRegistrationEnabled) &&
          // Phase C.6.2 (Candidate Homepage Visual Modernization): the primary-action area is now a
          // horizontal, hero-embedded CTA row (2 real <button> elements) instead of the C.6.1 vertical
          // sidebar stack — a pure presentation/markup change. The logo moved to the new hero band in
          // LandingPage_new_one.jsx (branding is now read there); this component's own job is strictly
          // the 2 CTAs + the login Modal it already owned. Zero authentication/registration logic
          // changed — same handlers, same routes, same validated form inside the unchanged Modal below.
          <div className="ent-home-cta-row">
            {this.state.registrationDisable === false && (
              <button
                type="button"
                className="ent-home-cta ent-home-cta-primary"
                onClick={(ev) => {
                  ev.preventDefault();
                  window.scrollTo(0, 0);
                  this.props.history.push(routes.registration.path);
                }}
              >
                <Text k="login.newRegistration" /> <Icon type="arrow-right" />
              </button>
            )}
            {/* Phase C.6.1: opens the existing validated login form in a compact Modal instead of a
                permanently-visible panel. Phase C.6.2: now a real <button>, not a clickable <div>, for
                correct semantics/keyboard behavior (§23) — same openLoginModal() handler. */}
            <button
              type="button"
              className="ent-home-cta ent-home-cta-secondary"
              onClick={this.openLoginModal}
            >
              <Icon type="user" /> <Text k="login.registeredCandidateLogin" />
            </button>
          </div>
        }

        <Modal
          title={<Text k="login.registeredCandidateLogin" />}
          visible={this.state.isLoginModalVisible}
          onCancel={this.closeLoginModal}
          footer={null}
          className="candidate-login-modal modal-global"
          destroyOnClose
        >
          {/* Phase C.6.1: keeps the exact same `login-form-wrap candidate` / `login-sec` ancestor
              classes the inline version had (themes.scss scopes several input/label rules through
              these — e.g. `.login-form-wrap.candidate .login-sec .form-control`, `.login-form-wrap
              label .displayInGrid`) — so the reused MyInput/Text markup renders pixel-identical
              inside the Modal, not a re-themed/unstyled variant. */}
          <div className="login-form-wrap candidate">
          <form onSubmit={this.handleLogin} className="login-sec">
            <MyInput
              wrapClass="mt-2"
              key="applicationID"
              type="number"
              value={this.state.applicationID}
              name="applicationID"
              onChange={this.onTextChange}
              placeholder={tr('login.applicationIdLabel')}
              // Stage 3.9 (Task 2): keeps the displayInGrid wrapper class — themes.scss's
              // .login-form-wrap label .displayInGrid rule (font-weight/color) still applies to
              // it; only the inner 2-stacked-div structure is replaced by <Text>'s own flat
              // bilingual rendering (no longer needs 2 divs to show 2 languages).
              heading={<span className="displayInGrid"><Text k="login.applicationIdLabel" /> <span className="color-red">*</span></span>}
              isRequired={false}
              errorState={this.state.applicationIDState}
              errorMessage={this.state.applicationIDError}
              className="custom-placeholder"
            />

            <MyInput
              wrapClass="mt-2"
              type="password"
              value={this.state.password}
              name="password"
              onChange={this.onTextChange}
              placeholder={tr('login.enterPassword')}
              heading={
                <div className="displayInGrid password-heading">
                  {/* Stage 3.8: class -> className (was a raw HTML attribute, invalid in
                      JSX — React logs an "Invalid DOM property `class`" console warning on
                      every render; zero rendered-output change). */}
                  {/* Stage 3.9 (Task 2): both displayInGrid wrappers kept — the outer one for
                      themes.scss's .login-form-wrap label .displayInGrid font-weight/color rule,
                      the inner one for the ".forgot-password-link .displayInGrid" bordered-pill
                      rule (App.scss ~899-914) — only the inner 2-div bilingual structure is
                      replaced by <Text>'s own flat rendering. */}
                  <span className="displayInGrid"><Text k="login.passwordLabel" /> <span className="color-red">*</span></span>
                  <a
                    href=""
                    tabIndex="-1"
                    onClick={(ev) => { ev.preventDefault(); this.closeLoginModal(); this.props.history.push(routes.forgotPassword.path); }}
                    className="forgot-password-link"
                  >
                    <div className="displayInGrid">
                      <Text k="login.forgotPassword" />
                    </div>
                  </a>
                </div>
              }
              isRequired={false}
              errorState={this.state.passwordState}
              errorMessage={this.state.passwordError}
            />

            {/* Phase C.6.1 §6 CAPTCHA decision: NOT added here. The existing StudentLogin backend
                contract (LoginModel: Application_Id/Password only — see RegistrationController.cs)
                has no CAPTCHA/security-code parameter, so a CAPTCHA field on this form could not
                actually be validated. Per this phase's own explicit rule ("never create a cosmetic
                CAPTCHA that appears security-protective but is not actually validated"), no CAPTCHA
                UI is rendered. Recorded as CAPTCHA LOGIN BACKEND SUPPORT = DEFERRED — see the C.6.1
                report's §7 for the minimum future backend work required. */}

            <div className="forget-sec w-100 text-center mt-4">
              <Button
                type="submit"
                className="button-global button-primary mb-3 autoHeight mt10"
                value={<div className='displayInGrid'><Text k="login.loginButton" /></div>}
              ></Button>
            </div>
          </form>
          </div>
          {this.state.isLoading && <LoadingSpinner />}
        </Modal>
        <a href={routes.home.basePath} hidden ref={this.homePageLink} onClick={() => { this.props.history.push(routes.home.basePath) }}></a>
        {!this.state.isRegistrationEnabled &&
          <div className="login-form-wrap position-relative w-100 form-wrap d-flex justify-content-center candidate">
            <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column ">
              <div className="pt-0 pl-4 pr-4 pb-4 w-100 text-center">
                <img alt='image' src={this.props.image} className="mt-0 registrationPageLogo projectLogoSizeWidth" />
              </div>
              <label className='blink_me  pl-4 pr-4' style={{ fontSize: '16px', color: 'red' }}>{BLACKLISTED_IP_MESSAGE}</label>
            </div>
          </div>

        }
      </>
    );
  }
}

export default withRouter(NewLogin);